<script>import SVG from "../elements/SVG.svelte";
import { attrValue } from "../../utils/html";
import TagWarning from "../elements/tags/variants/TagWarning.svelte";
import TagError from "../elements/tags/variants/TagError.svelte";
import { page } from "$app/stores";
import { onMount, tick } from "svelte";
import { viewport } from "../../stores";
import IconLottie from "../elements/IconLottie.svelte";
import { stickyAction } from "../../actions";
export let tabs;
export let activeTab = null;
export let props = {};
export let sticky = false;
export let top = null;
export let tabOffset;
let isScrollableRight = false;
let isScrollableLeft = false;
let isStuck = false;
let isMounted = false;
function handleStuck(e) {
  isStuck = e.detail.isStuck;
}
function handleScroll(target) {
  if (target) {
    isScrollableLeft = target.scrollLeft !== 0;
    isScrollableRight = target.scrollLeft < target.scrollWidth - target.clientWidth;
  }
}
onMount(async () => {
  let targetInit = document.getElementById(activeTab);
  targetInit?.scrollIntoView({ behavior: "smooth", inline: "center", block: "center" });
  isMounted = true;
  await tick();
  if (props.ref) {
    handleScroll(props.ref);
  }
});
const setActiveTabWithCallback = (indexTab, callback) => {
  if (callback) callback();
};
const onTabClick = (indexTab, callBack) => {
  setActiveTabWithCallback(indexTab, callBack);
};
$: tabs && tabs.map((tab, index) => {
  if (tab?.url) {
    if ($page?.url?.pathname.startsWith(tab.url)) activeTab = index;
  }
});
let scrollIndexValue = 100;
const previousClickItemFocus = () => {
  props.ref.scrollLeft -= scrollIndexValue;
};
const nextClickItemFocus = () => {
  props.ref.scrollLeft += scrollIndexValue;
};
</script>

{#if isMounted}
	<div
		use:stickyAction={{
			earlyReturn: !sticky,
			offset: tabOffset,
			stickToTop: true
		}}
		on:stuck={handleStuck}
		class:isStuck
		class={attrValue([
			'relative',
			sticky ? 'sticky top-0 z-[9] ' : '',
			!$viewport.isDesktop ? '-mx-3' : '',
			$viewport.isDesktop && sticky ? '' : '',
			'items-center mb-3'
		])}
		style={top
			? `--sticky-top: ${top[0]}px; --sticky-top-md: ${top[1]}px; --sticky-top-lg: ${top[2]}px; --sticky-top-xl: ${top[3]}px; --sticky-top-2xl: ${top[4]}px`
			: `top:${sticky ? tabOffset:0}px`}
	>
		{#if isScrollableLeft}
			<button
				class="scroll-indicator-left scroll-indicator"
				on:click={() => previousClickItemFocus()}
			>
				<IconLottie name="arrow_left" />
			</button>
		{/if}

		<div
			on:scroll={(e) => {
				if (e?.target) handleScroll(e?.target);
			}}
			id={props.id?.toString()}
			class={attrValue([
				'flex w-full items-center overflow-auto scroll-smooth snap-x',
				props.classNames ?? '',
				!$viewport.isDesktop ? 'px-3' : '',
				sticky ? 'sticky top-0 py-3' : '',
				' space-x-4 lg:space-x-3 2xl:space-x-4 items-center'
			])}
			class:custom-top={!!top}
			bind:this={props.ref}
			{...$$restProps}
		>
			{#each tabs as tab, i}
				<!-- svelte-ignore a11y-no-static-element-interactions -->
				<!-- svelte-ignore a11y-click-events-have-key-events -->
				<div
					id={i.toString()}
					on:click={() => {
						onTabClick(i, tab?.title.onClick);
					}}
					class="tab-nav snap-always snap-center justify-center whitespace-nowrap relative cursor-pointer flex space-x-2 font-semibold items-center {activeTab ===
					i
						? 'active '
						: ''}
					{'regular-tabs rounded-lg h-[35px] px-3 text-secondary whitespace-nowrap justify-center'}"
				>
					{#if tab.title.iconName}
						<SVG name={tab.title.iconName} />
					{/if}
					{#if tab.title.label}
						<div class="label block first-letter:uppercase">
							{tab.title.label}
						</div>
					{/if}

					{#if tab.title.nbItems}
						<div class="flex items-center {activeTab === i ? 'bg-white text-text' : 'bg-text text-white'} px-2 font-bold rounded-lg">
							{tab.title.nbItems}
						</div>
					{/if}
					{#if tab.title.tagLabel}
						{#if tab.title.tagType === 'warning'}
							<TagWarning props={{ label: tab.title.tagLabel }} />
						{/if}
						{#if tab.title.tagType === 'error'}
							<TagError props={{ label: tab.title.tagLabel }} />
						{/if}
					{/if}
				</div>
			{/each}
		</div>
		{#if isScrollableRight}
			<button class="scroll-indicator-right scroll-indicator" on:click={() => nextClickItemFocus()}>
				<IconLottie name="arrow_right" />
			</button>
		{/if}
	</div>
	<div>
		{#each tabs as { pane }, i}
			{#if pane}
				<div class="tab {activeTab === i ? 'block' : 'hidden'}">
					{#if pane?.type === 'html'}
						{@html pane?.content}
					{:else if pane?.type === 'string'}
						{pane?.content}
					{:else if pane?.type === 'component' && pane?.content}
						<svelte:component this={pane?.content.component} {...pane?.content.props} />
					{/if}
				</div>
			{/if}
		{/each}
	</div>
{/if}

<style>div.sticky.isStuck{border-bottom-width:1px;--tw-border-opacity:1;border-color:#e6e6e6;border-color:rgba(230,230,230,var(--tw-border-opacity,1));--tw-bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--tw-bg-opacity,1))}.desktop-sidebar.tab-nav.active .label{display:block}div :global(.regular-tabs.tab-nav){--tw-bg-opacity:1;background-color:#e6e6e6;background-color:rgba(230,230,230,var(--tw-bg-opacity,1));color:var(--color-secondary)}div :global(.regular-tabs.tab-nav.active){background-color:var(--color-text);--tw-text-opacity:1;color:#fff;color:rgba(255,255,255,var(--tw-text-opacity,1))}.custom-top{top:var(--sticky-top)}@media (min-width:768px){.custom-top{top:var(--sticky-top-md)}}@media (min-width:1024px){.custom-top{top:var(--sticky-top-lg)}}@media (min-width:1280px){.custom-top{top:var(--sticky-top-xl)}}@media (min-width:1536px){.custom-top{top:var(--sticky-top-2xl)}}.scroll-indicator{display:flex;height:38px;position:absolute;top:50%;z-index:9999;--tw-translate-y:-50%;align-items:center;transform:translate(var(--tw-translate-x),-50%) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.scroll-indicator-right{background:linear-gradient(270deg,#fff 20%,hsla(0,0%,100%,0) 80%);right:0}.scroll-indicator-left:after,.scroll-indicator-right:before{content:"";height:100%;width:30px}.scroll-indicator-left{background:linear-gradient(90deg,#fff 20%,hsla(0,0%,100%,0) 80%);left:0}</style>
